export default __webpack_public_path__ + "static/media/amex.9118c1b2.svg";